<template>
    <!--- Sidemenu -->
    <div id="sidebar-menu" style="z-index: 150">
        <!-- Left Menu Start -->
        <ul class="metismenu list-unstyled" id="side-menu" v-if="user">

                    <li class="nav-item dropdown allback homeItem" @click="chooseItem('homeItem')" >
                        <a href="javascript: void(0);" class="waves-effect">
                        <router-link class="nav-link dropdown-toggle arrow-none" :to="{name:'home'}"
                                     id="topnav-dashboard" role="button"
                                      aria-expanded="false">

                                <i class="bx bx-home-circle menu_i"></i>Accueil
                        </router-link>
                        </a>

                    </li>



                    <li class="nav-item dropdown allback categoriesItem" @click="chooseItem('categoriesItem')" v-if="user.type_compte=='suntechdev'">
                        <a href="javascript: void(0);" class="waves-effect">
                        <router-link class="nav-link dropdown-toggle arrow-none" :to="{name:'categories'}"
                                     id="topnav-categorie" role="button"
                                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="bx bx-list-ol "></i>Catégories
                        </router-link>
                        </a>
                    </li>

                    <li class="nav-item dropdown allback produitsItem" @click="chooseItem('produitsItem')"  v-if="user.type_compte=='suntechdev'">
                        <a href="javascript: void(0);" class="waves-effect">
                        <router-link class="nav-link dropdown-toggle arrow-none" :to="{name:'produits'}"
                                      role="button"
                                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="bx bxl-product-hunt "></i>Produits
                        </router-link>
                        </a>
                    </li>

                    <li class="nav-item dropdown allback precommandeadminItem" @click="chooseItem('precommandeadminItem')" v-if="user.type_compte=='suntechdev'">
                        <a href="javascript: void(0);" class="waves-effect">
                        <router-link class="nav-link dropdown-toggle arrow-none" :to="{name:'precommandeadmin'}"
                                      role="button"
                                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="bx bxl-medium-old "></i>

                            <v-badge
                                    v-if="precommandesEncours.length>0"
                                    color="green"
                                    :content="precommandesEncours.length"
                            >
                                Commandes
                            </v-badge>
                            <span v-else> Commandes</span>

                        </router-link>
                        </a>
                    </li>


                    <li class="nav-item dropdown allback userItem" @click="chooseItem('userItem')" v-if="user.type_compte=='suntechdev'">
                        <a href="javascript: void(0);" class="waves-effect">
                        <router-link class="nav-link dropdown-toggle arrow-none" :to="{name:'usersadmins'}"
                                     role="button"
                                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="bx bxs-user "></i>Utilisateurs
                        </router-link>
                        </a>

                    </li>
                    <li class="nav-item dropdown allback quartiersItem" @click="chooseItem('quartiersItem')"  v-if="user.type_compte=='suntechdev'">
                        <a href="javascript: void(0);" class="waves-effect">
                        <router-link class="nav-link dropdown-toggle arrow-none" :to="{name:'quartiers'}" role="button"
                                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="bx bxs-map "></i>Quartiers
                        </router-link>
                        </a>
                    </li>
                    <li class="nav-item dropdown allback pharmaciesItem" @click="chooseItem('pharmaciesItem')" v-if="user.type_compte=='suntechdev'">
                        <a href="javascript: void(0);" class="waves-effect">
                        <router-link class="nav-link dropdown-toggle arrow-none" :to="{name:'pharmacies'}" role="button"
                                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="bx bx-plus-medical "></i>Pharmacies
                        </router-link>
                        </a>
                    </li>
                    <li class="nav-item dropdown allback blogsItem" @click="chooseItem('blogsItem')" v-if="user.type_compte=='suntechdev'">
                        <a href="javascript: void(0);" class="waves-effect">
                        <router-link class="nav-link dropdown-toggle arrow-none" :to="{name:'blogs'}" role="button"
                                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="bx bxs-news "></i>Blogs
                        </router-link>
                        </a>
                    </li>
                    <li class="nav-item dropdown allback paiementsItem" @click="chooseItem('paiementsItem')" v-if="user.type_compte=='suntechdev'">
                        <a href="javascript: void(0);" class="waves-effect">
                        <router-link class="nav-link dropdown-toggle arrow-none" :to="{name:'paiement'}" role="button"
                                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="bx bxs-dollar-circle "></i>Paiements
                        </router-link>
                        </a>
                    </li>


                    <li class="nav-item dropdown allback tiersItem" @click="chooseItem('tiersItem')" v-if="user.type_compte=='suntechdev'">
                        <a class="nav-link dropdown-toggle arrow-none" href="#" id="topnav-uielement" role="button"
                           data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="bx bx-tone "></i>Tiers médicaux
                            <div class="arrow-down"></div>
                        </a>

                        <div class="dropdown-menu mega-dropdown-menu  dropdown-mega-menu-sm"
                             aria-labelledby="topnav-uielement"  style="width: 100%; padding-left: 3%">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div>
                                        <router-link  :to="{name:'tiers'}" class="dropdown-item sub_item_menu">Gestions</router-link>
                                        <router-link  :to="{name:'assureurs'}" class="dropdown-item sub_item_menu">Assureurs</router-link>
                                        <router-link  :to="{name:'tiers_types'}" class="dropdown-item sub_item_menu">Types</router-link>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </li>

                       

                    <li class="nav-item dropdown allback otherItem" @click="chooseItem('otherItem')" v-if="user.type_compte=='suntechdev'">
                        <a class="nav-link dropdown-toggle arrow-none" href="#" id="topnav-uielement" role="button"
                           data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="bx bx-poll "></i>Autres options
                            <div class="arrow-down"></div>
                        </a>

                        <div class="dropdown-menu mega-dropdown-menu  dropdown-mega-menu-sm"
                             aria-labelledby="topnav-uielement" style="width: 100%; padding-left: 3%">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="drop_item_menu" >
                                        <router-link :to="{name:'departements'}" class="dropdown-item sub_item_menu" >Départements
                                        </router-link>
                                    </div>


                                    <div>
                                        <router-link  :to="{name:'balance_storie'}" class="dropdown-item sub_item_menu">Historiques paiements</router-link>
                                    </div>
                                    <div>
                                        <router-link :to="{name:'formephamarcetique'}" class="dropdown-item sub_item_menu">Formes
                                            pharmaceutiques
                                        </router-link>
                                    </div>

                                    <div>
                                        <router-link  :to="{name:'roles'}" class="dropdown-item sub_item_menu">Rôles</router-link>
                                    </div>
                                    <div>
                                        <router-link :to="{name:'uploadexcel'}" class="dropdown-item sub_item_menu">Charger excel
                                        </router-link>
                                    </div>
                                    <div>
                                        <router-link :to="{name:'produitpharmaattribution'}" class="dropdown-item sub_item_menu">Ajout produit pharmacie
                                        </router-link>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </li>

                    <li class="nav-item dropdown allback pharmaproduitsItem" @click="chooseItem('pharmaproduitsItem')" v-if="(user.type_compte=='pharmacie' && GP)" >
                        <a href="javascript: void(0);" class="waves-effect">
                        <router-link class="nav-link dropdown-toggle arrow-none" :to="{name:'pharmaproduits'}"
                                     role="button"
                                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="bx bxl-product-hunt "></i>Mes Produits
                        </router-link>
                        </a>
                    </li>

                    <li class="nav-item dropdown allback precommandepharmaItem" @click="chooseItem('precommandepharmaItem')" v-if="(user.type_compte=='pharmacie' && GC )">
                        <a href="javascript: void(0);" class="waves-effect">
                        <router-link class="nav-link dropdown-toggle arrow-none" :to="{name:'precommandepharma'}"
                                     role="button"
                                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="bx bx-list-ol "></i>
                            <v-badge
                                    v-if="precommandesEncours.length>0"
                                    color="green"
                                    :content="precommandesEncours.length"
                            >
                                Mes Commandes
                            </v-badge>
                            <span v-else> Mes Commandes</span>
                        </router-link>
                        </a>
                    </li>

                    <li class="nav-item dropdown allback balanceItem" @click="chooseItem('balanceItem')" v-if="(user.type_compte=='pharmacie' && GB)">
                        <a href="javascript: void(0);" class="waves-effect">
                        <router-link class="nav-link dropdown-toggle arrow-none" :to="{name:'balance'}"  role="button"
                                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="bx bx-money"></i>Balance
                        </router-link>
                        </a>
                    </li>
                    <li class="nav-item dropdown allback askPayoutItem" @click="chooseItem('askPayoutItem')" v-if="(user.type_compte=='pharmacie' && DP )">
                        <a href="javascript: void(0);" class="waves-effect">
                        <router-link class="nav-link dropdown-toggle arrow-none" :to="{name:'askPayout'}"  role="button"
                                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="bx bxs-wallet-alt "></i>Demande de paiement
                        </router-link>
                        </a>
                    </li>
                   

                     <li class="nav-item dropdown allback userspharmacieItem " @click="chooseItem('userspharmacieItem')" v-if="(user.type_compte=='pharmacie' && GU )">
                        <a href="javascript: void(0);" class="waves-effect">
                        <router-link class="nav-link dropdown-toggle arrow-none" :to="{name:'userspharmacie'}"
                                     role="button"
                                     data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="bx bxs-user "></i>Utilisateurs
                        </router-link>
                        </a>

                    </li>
                    
                    <input type="hidden" :value="mineroles" id="ip_roles" />
 
        </ul>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    //import {getWithExpiry} from './../router/globalfunctions/auth_functions'

    import $ from "jquery";
    export default {
        name: "Menu",
        data() {
            return {
                user: JSON.parse(localStorage.getItem("user")),
                count: 0,
                roles:JSON.parse(localStorage.getItem("mineroles")),
                GB:false,
                GP:false,
                GC:false,
                GU:false,
                DP:false,
            }
        },
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvelle catégorie" : "Mise à jour"
            }
            ,
            ...mapState('precommandes/', ['precommandesEncours'])
            ,
            ...mapState('roleusers/', ['mineroles'])
        },
        mounted() {
           
            if (this.user.type_compte == "pharmacie")
            {

                let data = new FormData();
                data.append("state_client_get", "false");
                data.append("pharma_get", "false");
                data.append("pharmacie", this.user.relation._id);
                this.$store.dispatch('precommandes/getPrecommandeCours', data).then(response => {
                    window.console.log('precommandes', response)
                });

                this.GB = this.roles.includes("GB");
                this.GP = this.roles.includes("GP");
                this.GC = this.roles.includes("GC");
                this.GU = this.roles.includes("GU");
                this.DP = this.roles.includes("DP");


            }else{
                let data = new FormData();
                data.append("state_client_get", "false");
                data.append("pharma_get", "false");
                this.$store.dispatch('precommandes/getAdminPrecommandeCours', data).then(response => {
                    window.console.log('precommandes', response)
                });



            }


            
        },
        methods: {
             reloadpage(){
                location.reload();
            },
            chooseItem(chooseItem){
                $(".allback").removeClass("chooseitem");
                $("."+chooseItem).addClass("chooseitem");
            }
        }
    }


</script>

<style scoped>
    .nav-link {
        color: #2A3042;
        font-weight: bold;
    }

    .chooseitem{
        background-color: #096B97;
    }

</style>